/* global axios */

const accountUrl = id => `/api/v1/accounts/${id}`;

export default {
  initiateCall(accountId, conversationDisplayId) {
    return axios.post(
      `${accountUrl(accountId)}/conversations/${conversationDisplayId}/whatsapp_call`
    );
  },

  requestCallPermission(accountId, conversationDisplayId, bodyText) {
    return axios.post(
      `${accountUrl(accountId)}/conversations/${conversationDisplayId}/whatsapp_call/request_permission`,
      bodyText ? { body_text: bodyText } : {}
    );
  },
};
